module.exports = __webpack_public_path__ + "img/philosophy@2x.8dac2dc.jpg";